import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.lucky_wheel.loaded,
    props.lucky_wheel.opened,
    (loaded, opened) => {
        return {
            loaded,
            opened
        }
    }
)